import React, { FC } from 'react';

import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'next-i18next/pages';

import dayjs from 'dayjs';

import DeletedIcon from '@/assets/help-center/deleted.svg';
import SelectedIcon from '@/assets/help-center/selected.svg';
import { TelegramIcon, WhatsAppIcon } from '@/components/Footer/icons';
import {
	FISHPLACE_PHONE_URL,
	FISHPLACE_SUPPORT_EMAIL_URL,
	MAKE_SPRAVOCHNIY_CENTR_LINK,
	TG_CHANNEL_FISHPLACE_URL,
	WHATSAPP_FISHPLACE_URL,
} from '@/constants/routes';
import { TranslationNamespace } from '@/i18n';

import styles from './ContactInfoSection.module.scss';

export const ContactInfoSection: FC = () => {
	const { t } = useTranslation(TranslationNamespace.Marketing);
	const UTC = dayjs().utcOffset();

	const VladivostokTime = dayjs().add(-UTC, 'minute').add(10, 'hour');

	const isWorkTime = VladivostokTime.isBetween(
		VladivostokTime.startOf('day').hour(9),
		VladivostokTime.startOf('day').hour(18),
	);

	const getAvailableText = () => {
		return t(
			isWorkTime
				? 'about-us-container.we-are-available-now'
				: 'about-us-container.we-are-not-available-now-but-you-can-leave-us-a-message',
		);
	};

	return (
		<section className={styles.contactInfoSection}>
			<div className={styles.content}>
				<div className={styles.descriptionBlock}>
					<div className={styles.title}>{t('about-us-container.have-questions')}</div>
					<div className={styles.description}>
						{t(
							'about-us-container.refer-to-the-reference-information-on-working-on-the-platform-collected',
						)}
					</div>
					<Link className={styles.link} href={MAKE_SPRAVOCHNIY_CENTR_LINK()}>
						{t('about-us-container.help-center')}
					</Link>
				</div>

				<div className={styles.contactInfoBlock}>
					<div className={styles.contactPhone}>
						<a href={FISHPLACE_PHONE_URL}>+7 908 999 80 80</a>
					</div>
					<div className={styles.openInfoBlock}>
						<div className={styles.openInfo}>
							{isWorkTime ? (
								<Image className={styles.icon} src={SelectedIcon} width={16} height={16} alt="" />
							) : (
								<Image className={styles.icon} src={DeletedIcon} width={16} height={16} alt="" />
							)}
							<div>{t('about-us-container.we-work-from-9-00-to-19-00-utc-10')}</div>
						</div>
						<div className={styles.additionalOpenInfo}>{getAvailableText()}</div>
					</div>

					<div className={styles.mail}>
						<a href={FISHPLACE_SUPPORT_EMAIL_URL}>support@fishplace.ru</a>
					</div>
					<div className={styles.icons}>
						<a href={TG_CHANNEL_FISHPLACE_URL} target="_blank" rel="noreferrer">
							<TelegramIcon />
						</a>
						<a href={WHATSAPP_FISHPLACE_URL} target="_blank" rel="noreferrer">
							<WhatsAppIcon />
						</a>
					</div>
				</div>
			</div>
		</section>
	);
};
